import React, { lazy, useEffect, useState } from 'react'

import LeftMenu from '../components/LeftMenu'
import PrivateRoute from '../components/PrivateRoute'

import { shallowEqual, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Loader from '../components/Loader'
import Logout from './login/Logout'

const Dashboard = lazy(() =>import("./Dashboard"));
const UserForm = lazy(() =>import("./form/UserForm"));
const Receipts = lazy(() =>import("./invoice/Receipts"));

const hdfcLogo = lazy(() =>import("./../../styles/img/icons/hdfc.svg"));

export default function App() {

  const store = useSelector(connectToStore, shallowEqual);
  
  const [isEdit, setIsEdit] = useState(false);

  const location=useLocation()
  
  useEffect(()=>{
    let editPage=false
    if(location?.pathname.includes('form/edit')){
      editPage=true
    }
    setIsEdit(editPage)

    
  },[location])


  function renderRoutes(){
    return(
      <>
        <PrivateRoute path='/dashboard' element={<Dashboard/>}/>       
        <PrivateRoute path='/receipt' element={<Receipts/>}/> 
        <PrivateRoute exact path='/:formId/form/edit' element={<UserForm/>}/> 
        <PrivateRoute exact path='/logout' element={<Logout/>}/> 
      </>
    )
  }

  function renderLeftMenu(){
    return <LeftMenu />
  }


  function renderFooter() {
    return (
      <div className="dashboard-footer">
        <div className="footer-bg">
          <div className="footer-content">
            <span className="text-[#211F26] text-[12px]">Powered by</span>
            <img src={hdfcLogo} alt="" />
          </div>
        </div>
      </div>
    )
  }
 
  return (
    <div className="home-container">
      <Loader show={store.showPageLoader || store.showDashboardPageLoader}  />
      {!isEdit &&renderLeftMenu()}
      <div id={isEdit?"": "main-container"}>
          {renderRoutes()}
      </div>
      {!isEdit && renderFooter()}
    </div>
  )

  function connectToStore(store) {
    return {
        showPageLoader: store.payment.showPageLoader,
        showDashboardPageLoader: store.dashboard.showPageLoader,
      };
  }
}
